import { cva } from 'class-variance-authority';

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: {
      large: 'text-size-h2 ml-2.5',
      normal: 'text-size-h3 ml-[10px]',
      small: 'text-size-h5 ml-1.5',
    },
  },
  defaultVariants: { size: 'normal' },
});
